<template>
    <div>
        <SVGQuote v-if="$i18n.locale == 'en'"></SVGQuote>
        <SVGQuoteFr v-else class="flip"></SVGQuoteFr>
        <div class="quote-underline"
            :style="{backgroundColor: bgColor}">
        </div>
    </div>
</template>

<script>
import SVGQuote from '@/assets/icons/quote.svg'
import SVGQuoteFr from '@/assets/icons/quote-fr.svg'

export default {
  name: 'QuoteHeader',
  components: {
      SVGQuote,
      SVGQuoteFr
  },
  props: [
      'bgColor'
  ]
}
</script>

<style scoped>
svg {
    width: 100px;
}
.quote-underline {
    width: 205px;
    height: 50px;
    background-image: url(../../assets/images/quote-block-texture.png);
    background-repeat: no-repeat;
    background-blend-mode: multiply;
    background-position: 200%, 0;
    margin: 25px 0 50px 0;
}

</style>